import { denialReasonsApi } from 'app/services/api';
import _ from 'lodash';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const DENIAL_REASONS_ACTION_TYPE = createNamedActions('denialReasons', {
  GET_HMDA_CODES: 'GET_HMDA_CODES',
  GET_DENIAL_REASONS: 'GET_DENIAL_REASONS',
  CREATE_DENIAL_REASON: 'CREATE_DENIAL_REASON',
  EDIT_DENIAL_REASON: 'EDIT_DENIAL_REASON',
  DELETE_DENIAL_REASON: 'DELETE_DENIAL_REASON',
});

const denialReasonsSchema = new schema.Entity(
  'data',
  {},
  {
    idAttribute: 'id',
    processStrategy: ({
      id,
      companyId,
      name,
      hmdaCode,
      otherReason,
      denialDueToCredit,
      isAffiliate,
    }) => ({
      id,
      companyId,
      name,
      HMDACode: hmdaCode,
      otherReason,
      isDenialDueToCredit: denialDueToCredit,
      isAffiliate,
    }),
  },
);

export const getHMDACodesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await denialReasonsApi.getHMDACodes();

  return dispatch({
    type: DENIAL_REASONS_ACTION_TYPE.GET_HMDA_CODES,
    payload: data,
  });
});

export const getDenialReasonsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await denialReasonsApi.getDenialReasons();

  return dispatch({
    type: DENIAL_REASONS_ACTION_TYPE.GET_DENIAL_REASONS,
    payload: normalize(data, [denialReasonsSchema]).entities.data,
  });
});

export const createDenialReasonAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await denialReasonsApi.createDenialReason({
    ..._.omit(params, 'isDenialDueToCredit'),
    denialDueToCredit: params.isDenialDueToCredit,
  });
  const normalizedData = normalize(data, denialReasonsSchema);

  return dispatch({
    type: DENIAL_REASONS_ACTION_TYPE.CREATE_DENIAL_REASON,
    payload: normalizedData.entities.data[normalizedData.result],
  });
});

export const editDenialReasonAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await denialReasonsApi.editDenialReason({
    ..._.omit(params, 'isDenialDueToCredit'),
    denialDueToCredit: params.isDenialDueToCredit,
  });
  const normalizedData = normalize(data, denialReasonsSchema);

  return dispatch({
    type: DENIAL_REASONS_ACTION_TYPE.EDIT_DENIAL_REASON,
    payload: normalizedData.entities.data[normalizedData.result],
  });
});

export const deleteDenialReasonAction = catchAsyncActionError(params => async dispatch => {
  await denialReasonsApi.deleteDenialReason(params);

  return dispatch({
    type: DENIAL_REASONS_ACTION_TYPE.DELETE_DENIAL_REASON,
    meta: params,
  });
});
